import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { updateStyles } from '../../../../redux/slices/userActivity';

export default function FontStyles() {

    const { selectedUserActivity, userActivities, selectedComponent } = useSelector((state) => state.userActivity);
    const [styles, setStyles] = useState({});
    const [boldActive, setBoldActive] = useState(false)
    const [italicActive, setItalicActive] = useState(false)
    const [underlineActive, setUnderlineActive] = useState(false)
    
    const dispatch = useDispatch()

    useEffect(() => {
        if (Object.keys(userActivities[selectedUserActivity]).length > 1) {
            setStyles(userActivities[selectedUserActivity].theme_id.styles.styles);
        }
    }, [selectedUserActivity, Object.keys(userActivities[selectedUserActivity]).length, userActivities[selectedUserActivity]]);

    useEffect(() => {
       if(styles[selectedComponent.name] === undefined) return
       styles[selectedComponent.name].fontWeight > 599 ? setBoldActive(true) : setBoldActive(false)
       styles[selectedComponent.name].fontStyle === 'italic' ? setItalicActive(true) : setItalicActive(false)
       styles[selectedComponent.name].textDecoration === 'underline' ? setUnderlineActive(true) : setUnderlineActive(false)
    }, [selectedComponent, selectedUserActivity, userActivities[selectedUserActivity], styles ])

    const handleBoldText = () => {
        let bold = false
        if (styles[selectedComponent.name].fontWeight > 599) {
            bold = true
        }
        if (Object.keys(userActivities[selectedUserActivity]).length > 1) {
            let tempStyles = { ...styles };
            let value = bold ? 'normal' : 600

            tempStyles[selectedComponent.name] = {
                ...styles[selectedComponent.name],
                fontWeight: value,
            };
            setStyles(tempStyles);
            dispatch(
                updateStyles({
                    selectedActivityIdx: selectedUserActivity,
                    style: tempStyles,
                })
            );
        }
    }

    const handleTextUnderline = () => {
        let underlined = false
        if (styles[selectedComponent.name].textDecoration === 'underline') {
            underlined = true
        }
        if (Object.keys(userActivities[selectedUserActivity]).length > 1) {
            let tempStyles = { ...styles };
            let value = underlined ? 'none' : 'underline'
            tempStyles[selectedComponent.name] = {
                ...styles[selectedComponent.name],
                textDecoration: value,
            };
            setStyles(tempStyles);
            dispatch(
                updateStyles({
                    selectedActivityIdx: selectedUserActivity,
                    style: tempStyles,
                })
            );
        }
    }

    const handleTextItalic = () => {
        let isItalic = false
        if (styles[selectedComponent.name].fontStyle === 'italic') {
            isItalic = true
        }
        if (Object.keys(userActivities[selectedUserActivity]).length > 1) {
            let tempStyles = { ...styles };
            let value = isItalic ? 'normal' : 'italic'
            tempStyles[selectedComponent.name] = {
                ...styles[selectedComponent.name],
                fontStyle: value,
            };
            setStyles(tempStyles);
            dispatch(
                updateStyles({
                    selectedActivityIdx: selectedUserActivity,
                    style: tempStyles,
                })
            );
        }
    }

    return (
        <div className='text_editor_item font-styles-editor mr-4'>
            <div className='icon' onClick={handleBoldText} 
            style={{
                borderTopLeftRadius: '8px',
                borderBottomLeftRadius: '8px',
            }} 
            id={boldActive ? 'active' : ''} >
                <img src='/assets/icons/bold.svg' />
            </div>
            <div className='italic-icon icon' onClick={handleTextItalic} id={italicActive ? 'active' : ''} >
                <img src='/assets/icons/italic.svg' />
            </div>
            <div className='icon' onClick={handleTextUnderline}
             style={{
                borderTopRightRadius: '8px',
                borderBottomRightRadius: '8px',
            }} 
            id={underlineActive ? 'active' : ''}>
                <img src='/assets/icons/underlined.svg' />
            </div>
        </div>
    )
}
